import React from 'react';

export const DiscountBadge = () => {
  const discount = Math.round(window.variantDataSelector.getMaxSubscriptionDiscount());

  return (
    <div className="cart-popup__discount-badge discount-badge">
      <p>
        <b>Discount Auto-Applied!</b> You will get up to {discount}% off on your first month subscription
      </p>
    </div>
  );
};
